import { render, staticRenderFns } from "./formDetail.vue?vue&type=template&id=c844cd8e&scoped=true"
import script from "./formDetail.vue?vue&type=script&lang=js"
export * from "./formDetail.vue?vue&type=script&lang=js"
import style0 from "./formDetail.vue?vue&type=style&index=0&id=c844cd8e&prod&scoped=true&lang=css"
import style1 from "./formDetail.vue?vue&type=style&index=1&id=c844cd8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c844cd8e",
  null
  
)

export default component.exports